import { gql, useLazyQuery } from "@apollo/client";
import { GetTermsAndConditionsByIdQuery } from "../types/types";

const GET_FILE_BY_ID_QUERY = gql(`
  query GetTermsAndConditionsById($fileId: String!) {
    getTermsAndConditionsById(id: $fileId) {
      fileName
      contentType
      downloadUrl
    }
  }
`);

export function useGetFileById() {
  const [getFile, { loading }] = useLazyQuery<GetTermsAndConditionsByIdQuery>(GET_FILE_BY_ID_QUERY);

  const handleDownload = async (fileId: string, openInNewTab: boolean = false) => {
    if (!fileId) return;
    
    const { data } = await getFile({ variables: { fileId } });
    const file = data?.getTermsAndConditionsById;
    if (!file?.downloadUrl) return;
  
    try {
      const response = await fetch(file.downloadUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      
      // Preuzimanje datoteke
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = file.fileName || 'document';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Ako je potrebno, otvori u novom prozoru
      if (openInNewTab) {
        window.open(blobUrl, '_blank');
      }
      
      setTimeout(() => {
        window.URL.revokeObjectURL(blobUrl);
      }, 500);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  const handleOpen = async (fileId: string) => {
    if (!fileId) return;

    const { data } = await getFile({ variables: { fileId } });
    const file = data?.getTermsAndConditionsById;
    if (!file?.downloadUrl) return;

    try {
      const response = await fetch(file.downloadUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      
      window.open(blobUrl, '_blank');
      
      setTimeout(() => {
        window.URL.revokeObjectURL(blobUrl);
      }, 100);
    } catch (error) {
      console.error('Error opening file:', error);
    }
  };

  return {
    downloadFile: handleDownload,
    openFile: handleOpen,
    loading
  };
}